// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-g3jCK","disabled":"jgp-1bzuK","icon":"jgp-XdHto"};